import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = theme => ({
	root: {
		paddingLeft: "30px",
		marginBottom: "60px",
	},
	noPaddingRoot: {
		paddingLeft: 0,
	},
	header: {
		fontFamily: theme.fonts.bold,
		fontSize: "18px",
		lineHeight: 2,
		letterSpacing: "2px",
		color: theme.palette.colors.darkSlateBlue,
		marginBottom: "26px",
		textTransform: "uppercase",
		position: "relative",
		display: "inline-block",
		paddingRight: "32px",
	},
	headerOffset: {
		marginLeft: "30px",
	},
	headerToggle: {
		display: "none",
		position: "absolute",
		cursor: "pointer",
		color: theme.palette.colors.purplishBlue,
		right: "0",
		top: "-1px",
		fontSize: "20px",
	},
	headerToggleIsClose: {},
	headerToggleIsOpen: {},
	bodyWrapper: {},
	bodyOffset: {
		marginLeft: "30px",
	},
	body: {},
	isOpen: {},
	isUnderline: {
		"& > $header": {
			marginBottom: "50px",
			position: "relative",
			"&:before": {
				content: "''",
				position: "absolute",
				left: 0,
				width: "79px",
				height: "2px",
				backgroundColor: theme.palette.colors.purplishBlue,
				bottom: "-12px",
			},
		},
	},
	small: {
		padding: 0,
		marginBottom: 0,
		"& > $header": {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: 1.29,
			cursor: "pointer",
			marginBottom: 0,
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			textTransform: "uppercase",
			"& > $headerToggleIsClose": {
				display: "block",
			},
			"& > $headerToggleIsOpen": {
				display: "none",
			},
		},

		"& > $bodyWrapper": {
			maxHeight: 0,
			overflow: "hidden",
			padding: "0",
		},
		"&$isOpen": {
			"& > $header": {
				marginBottom: "24px",
				"& > $headerToggleIsClose": {
					display: "none",
				},
				"& > $headerToggleIsOpen": {
					display: "block",
				},
			},
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		header: {},
		isUnderline: {
			"& > $header": {
				"&:before": {
					width: "58px",
				},
			},
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			paddingLeft: "20px",
			marginBottom: "40px",
		},
		noPaddingRoot: {
			paddingLeft: 0,
		},
		header: {
			fontSize: "16px",
			lineHeight: 1.25,
			letterSpacing: "1.8px",
			marginBottom: "24px",
		},
		headerOffset: {
			marginLeft: "20px",
		},
		isUnderline: {
			marginBottom: "69px",
			"& > $header": {
				marginBottom: "55px",
				"&:before": {
					width: "48px",
					bottom: "-19px",
				},
			},
		},
		small: {
			paddingLeft: 0,
			marginBottom: 0,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			paddingLeft: 0,
			marginBottom: 0,
		},
		header: {
			fontSize: "16px",
			lineHeight: 1.25,
			letterSpacing: "1.8px",
			marginBottom: "0",
			cursor: "pointer",
		},
		headerOffset: {
			marginLeft: 0,
		},
		headerToggleIsClose: {
			display: "block",
		},
		headerToggleIsOpen: {
			display: "none",
		},
		bodyWrapper: {
			maxHeight: 0,
			overflow: "hidden",
			padding: "0",
		},
		bodyOffset: {
			marginLeft: 0,
		},
		body: {},
		isOpen: {
			"& > $header": {
				marginBottom: "24px",
			},
			"& $headerToggleIsClose": {
				display: "none",
			},
			"& $headerToggleIsOpen": {
				display: "block",
			},
		},
		isUnderline: {
			marginBottom: 0,
			"& > $header": {
				marginBottom: 0,
				position: "relative",
				"&:before": {
					display: "none",
				},
			},
			"&$isOpen": {
				"& > $header": {
					marginBottom: "24px",
				},
			},
		},
		small: {
			"& > $header": {
				fontSize: "12px",
				"& > $headerToggle": {
					top: "-3px",
				},
			},
			"&$isOpen": {
				"& > $header": {
					marginBottom: "12px",
				},
			},
		},
	},
});

class CollapseBlock extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	toggleBlock() {
		if (this.props.windowSize.xs || !!this.props.small) {
			if (!this.state.open) {
				this.parent.style.maxHeight = "10000px";
			} else {
				this.parent.style.maxHeight = 0;
			}
			this.setState({
				open: !this.state.open,
			});
		}
	}

	render() {
		let classes = this.props.classes;
		return (
			<div
				className={classNames(classes.root, {
					[classes.isUnderline]: !!this.props.underline,
					[classes.isOpen]: this.state.open,
					[classes.small]: this.props.small,
					[classes.noPaddingRoot]: this.props.baseOffset,
				})}
			>
				<div
					className={classNames(classes.header, {
						[classes.headerOffset]: this.props.baseOffset,
					})}
					onClick={() => this.toggleBlock()}
				>
					<span>{this.props.header}</span>
					<span
						className={classNames(
							classes.headerToggle,
							classes.headerToggleIsClose,
							"icon24 icon-arrow-1-down"
						)}
					/>
					<span
						className={classNames(
							classes.headerToggle,
							classes.headerToggleIsOpen,
							"icon24 icon-arrow-1-up"
						)}
					/>
				</div>
				<div className={classes.bodyWrapper} ref={parent => (this.parent = parent)}>
					<div className={classes.body} ref={list => (this.list = list)}>
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(CollapseBlock);
